import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link, useParams } from 'react-router-dom';
import { RESERVA_BASE } from './reserva';
import { ReservaNav, useNoIndex } from './RivieraInventario';
import { vitrine, formatarPreco, detalhesDaCasa, STATUS } from './casasApi';

/*
  Página de uma casa do cadastro do Fábio (tarefa 87c272e9). Lê a mesma vitrine
  pública do /casas: casa vendida ou tirada do site some daqui também, sem
  precisar de outra regra. O botão leva ao formulário da página reserva, que
  já entrega o lead na Bianca.
*/

const azul = '#005BAA';
const tinta = '#13314e';

const Page = styled.main`
  min-height: 100svh; background: #f7fbfd; color: ${tinta};
  font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif;
`;
const Top = styled.header`
  background: #fff; border-bottom: 1px solid #e3edf5; padding: 16px;
  display: grid; gap: 14px; justify-items: center;
  img { height: 84px; width: auto; margin: -14px 0; }
`;
const Body = styled.section`
  /* Texto de anúncio centralizado (CSS global do site) cansa a leitura: alinha à esquerda. */
  max-width: 980px; margin: 0 auto; padding: 20px 16px 64px; text-align: left;
  .voltar { color: ${azul}; font-weight: 700; text-decoration: none; font-size: 14px; }
  h1 { font-size: 26px; margin: 14px 0 6px; line-height: 1.2; }
  .local { color: #56708a; margin: 0 0 14px; }
  .preco { font-size: 24px; font-weight: 800; color: ${azul}; margin: 6px 0 14px; }
  .selo { display: inline-block; background: #fff4e5; color: #8a4b00; font-weight: 700; font-size: 13px; padding: 5px 12px; border-radius: 999px; margin-left: 8px; vertical-align: middle; }
  ul { margin: 0 0 18px; padding: 0; list-style: none; display: flex; flex-wrap: wrap; gap: 8px; }
  li { font-size: 14px; background: #eef5fb; padding: 6px 12px; border-radius: 999px; }
  .desc { white-space: pre-line; line-height: 1.6; font-size: 16px; }
  .cta { display: inline-block; margin-top: 22px; background: ${azul}; color: #fff; padding: 14px 24px; border-radius: 999px; text-decoration: none; font-weight: 800; }
`;
const Galeria = styled.div`
  display: grid; gap: 8px; margin: 10px 0 18px;
  .principal { width: 100%; aspect-ratio: 4 / 3; object-fit: cover; border-radius: 16px; display: block; background: #e3edf5; }
  .miniaturas { display: flex; gap: 8px; overflow-x: auto; padding-bottom: 4px; }
  .miniaturas button { flex: 0 0 auto; border: 2px solid transparent; padding: 0; border-radius: 10px; overflow: hidden; background: none; cursor: pointer; }
  .miniaturas button[aria-current='true'] { border-color: ${azul}; }
  .miniaturas img { width: 84px; height: 64px; object-fit: cover; display: block; }
`;

export default function RivieraCasa() {
  useNoIndex();
  const { id } = useParams();
  const [casa, setCasa] = useState(undefined);
  const [foto, setFoto] = useState(0);
  useEffect(() => {
    let vivo = true;
    vitrine().then((lista) => { if (vivo) setCasa(lista.find((c) => c.id === id) || null); })
      .catch(() => { if (vivo) setCasa(null); });
    return () => { vivo = false; };
  }, [id]);
  useEffect(() => { if (casa) document.title = `${casa.titulo} · Riviera de Santa Cristina`; }, [casa]);

  const fotos = casa?.fotos?.length ? casa.fotos : [{ url: '/riviera/hero-peninsula.jpg', id: 'vista' }];
  return (
    <Page>
      <Top>
        <Link to={RESERVA_BASE} aria-label="Voltar ao início"><img src="/riviera/logo.png" alt="Riviera de Santa Cristina XIII" /></Link>
        <ReservaNav ativo="casas" tom="escuro" />
      </Top>
      <Body>
        <Link className="voltar" to={`${RESERVA_BASE}/casas`}>← Todas as casas</Link>
        {casa === undefined && <p>Carregando…</p>}
        {casa === null && <p>Esta casa não está mais disponível. <Link to={`${RESERVA_BASE}/casas`}>Ver as outras</Link></p>}
        {casa && (
          <>
            <h1>{casa.titulo}{casa.status === 'reservado' && <span className="selo">{STATUS.reservado}</span>}</h1>
            <p className="local">Riviera de Santa Cristina XIII · Paranapanema, SP · Represa Jurumirim</p>
            <Galeria>
              <img className="principal" src={fotos[Math.min(foto, fotos.length - 1)].url} alt={casa.titulo} />
              {fotos.length > 1 && (
                <div className="miniaturas">
                  {fotos.map((f, i) => (
                    <button key={f.id} type="button" aria-current={i === foto} onClick={() => setFoto(i)} aria-label={`Foto ${i + 1}`}>
                      <img src={f.url} alt="" loading="lazy" />
                    </button>
                  ))}
                </div>
              )}
            </Galeria>
            <div className="preco">{formatarPreco(casa.preco) || 'Consulte o valor'}</div>
            <ul>
              {detalhesDaCasa(casa).map((d) => <li key={d}>{d}</li>)}
              {casa.condominio_mensal ? <li>Condomínio {formatarPreco(casa.condominio_mensal)}/mês</li> : null}
              {casa.aceita_fgts ? <li>Aceita FGTS</li> : null}
              {casa.mobiliado === 'completo' ? <li>Mobiliada</li> : casa.mobiliado === 'planejados' ? <li>Com planejados</li> : null}
            </ul>
            {casa.descricao && <p className="desc">{casa.descricao}</p>}
            <Link className="cta" to={`${RESERVA_BASE}#agendar`}>Quero visitar esta casa</Link>
          </>
        )}
      </Body>
    </Page>
  );
}
